module.exports = __webpack_public_path__ + "img/scp-pods.02db34e2.png";